import { Helmet } from 'react-helmet-async';
import dayjs from 'dayjs';
import { useState, useCallback, useEffect } from 'react';
import io from 'socket.io-client';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  CircularProgress,
  Box,
  Grid,
  Pagination,
  IconButton,
  MenuItem,
  FormControl,
  InputLabel,
  FormGroup,
  Checkbox,
  FormControlLabel,
  Select,
  TextField,
  Autocomplete,

} from '@mui/material';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// components
import Iconify from '../components/iconify';


import { UserListHead } from '../sections/@dashboard/user';


// hooks
import { useAxios } from '../context/AxiosHookContext';

// ----------------------------------------------------------------------

const TABLE_HEAD_TYPES = [
  { id: '', label: 'Técnico', alignRight: false },
  { id: '', label: 'Núm. Ticket', alignRight: false },
  { id: '', label: 'Solicitante', alignRight: false },
  { id: '', label: 'Estado', alignRight: false }
];

// ----------------------------------------------------------------------

const ReportTicketsPageBase = () => {

  const [loading, setLoading] = useState(false);
  const [loadingExcelReport, setLoadingExcelReport] = useState(false);
  const [supportList, setSupportList] = useState([]);
  const [ticketsReport, setTicketsReport] = useState({});
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [ticketList, setActivitiesList] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState(["Created", "Assigned"]);
  const [filterName, setFilterName] = useState("");
  const [supportAssigned, setSupportAssigned] = useState({ _id: 0, displayName: "Todos" });
  const [categoryList, setCategoryList] = useState([]);
  const [categoriesSelected, setCategoriesSelected] = useState([])
  const [officeLocations, setOfficeLocations] = useState([]);
  const [officeLocation, setOfficeLocation] = useState([])
  const [openSupportList, setOpenSupportLis] = useState(false);
  const TICKETS__API = `/tickets`;
  const axios = useAxios();
  const [startDay, setStartDay] = useState(dayjs("2000-01-01").startOf('day'));
  const [endDay, setEndDay] = useState(dayjs().endOf('day'))


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const getTicketsReport = useCallback(async () => {
    try {

      setLoading(true);

      let FILTER = '';

      FILTER += selectedTypes.length > 0 ? `&status=${JSON.stringify(selectedTypes)}` : '';
      FILTER += officeLocation.length > 0 ? `&officeLocation=${JSON.stringify(officeLocation)}` : '';
      FILTER += categoriesSelected.length > 0 && categoriesSelected.some(item => item._id === 0) === false ? `&support_type=${JSON.stringify(categoriesSelected.map(item => item._id))}` : '';
      FILTER += supportAssigned?._id ? `&support_assigned=${supportAssigned._id}` : '';
      FILTER += `&startDay=${startDay.toISOString()}`;
      FILTER += `&endDay=${endDay.toISOString()}`;

      const { data } = await axios.get(`${TICKETS__API}/report?${FILTER}`);
      setTicketsReport(data.data);

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [axios, TICKETS__API, startDay, endDay, setLoading, supportAssigned, officeLocation, selectedTypes, categoriesSelected]);


  const getExcelReport = useCallback(async () => {
    try {

      setLoadingExcelReport(true);
      let FILTER = '';

      FILTER += selectedTypes.length > 0 ? `&status=${JSON.stringify(selectedTypes)}` : '';
      FILTER += officeLocation.length > 0 ? `&officeLocation=${JSON.stringify(officeLocation)}` : '';
      FILTER += categoriesSelected.length > 0 && categoriesSelected.some(item => item._id === 0) === false ? `&support_type=${JSON.stringify(categoriesSelected.map(item => item._id))}` : '';
      FILTER += supportAssigned?._id ? `&support_assigned=${supportAssigned._id}` : '';
      FILTER += `&startDay=${startDay.toISOString()}`;
      FILTER += `&endDay=${endDay.toISOString()}`;

      const response = await axios.get(`${TICKETS__API}/report_excel?${FILTER}`, {
        responseType: 'blob' // Indica que esperas una respuesta de tipo Blob
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));

      // Crear un enlace <a> para iniciar la descarga
      const a = document.createElement('a');
      a.href = url;
      a.download = `reporte.xlsx`; // Nombre del archivo para descargar
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

    } catch (error) {
      console.log(error);
    } finally {
      setLoadingExcelReport(false)
    }
  }, [axios, TICKETS__API, startDay, endDay, setLoading, supportAssigned, officeLocation, selectedTypes, categoriesSelected]);


  const getSupports = useCallback(async () => {
    try {
      const USERS_API = `/users?page=${1}&limit=30${filterName ? `&displayName=${filterName}` : ''}&role=${"Soporte"}`
      setSupportList([])
      setLoading(true);
      const { data } = await axios.get(USERS_API);
      setSupportList([...data?.data?.list]);

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [axios, setLoading]);


  const getTickets = useCallback(async () => {
    try {
      setActivitiesList([])
      setLoading(true);

      let FILTER = '';

      FILTER += selectedTypes.length > 0 ? `&status=${JSON.stringify(selectedTypes)}` : '';
      FILTER += officeLocation.length > 0 ? `&officeLocation=${JSON.stringify(officeLocation)}` : '';
      FILTER += categoriesSelected.length > 0 ? `&support_type=${JSON.stringify(categoriesSelected.map(item => item._id))}` : '';
      FILTER += supportAssigned?._id ? `&support_assigned=${supportAssigned._id}` : '';
      FILTER += `&startDay=${startDay.toISOString()}`;
      FILTER += `&endDay=${endDay.toISOString()}`;

      const { data } = await axios.get(`${TICKETS__API}?page=${page}&size=${10}${FILTER}`);
      setActivitiesList(data?.data?.list || []);
      setTotalPages(data?.data?.total_pages || 1);

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [axios, TICKETS__API, startDay, endDay, setActivitiesList, setLoading, supportAssigned, officeLocation, selectedTypes, categoriesSelected, page]);


  useEffect(() => {
    const categories = async () => {
      try {
        const types = JSON.stringify(["support_type"])
        const { data } = await axios.get(`/tickets/category?page=1&limit=50000&types=${types}`);

        const mapped = [...data?.data?.list || []].map(item => {
          return { _id: item._id, displayName: item.displayName };
        });

        setCategoryList(mapped);
        setCategoriesSelected(mapped);

      } catch (error) {
        console.log(error)
      }
    }

    const getOfficeLocations = async () => {
      try {

        const { data } = await axios.get(`/users/officeLocations`);
        setOfficeLocations([...data?.data || []].map(item => item.department));

      } catch (error) {
        console.log(error)
      }
    }

    getOfficeLocations()
    categories()
  }, [])


  useEffect(() => {

    const interval = setInterval(() => {
      getTicketsReport();
      getTickets();
      getSupports();
    }, 20000);

    // Limpieza del intervalo cuando el componente se desmonta
    return () => clearInterval(interval);

  }, [getTicketsReport, startDay, endDay, selectedTypes, officeLocation, categoriesSelected, supportAssigned, page])

  useEffect(() => {
    getTicketsReport();
    getTickets();
    getSupports();
  }, [getTicketsReport, startDay, endDay, selectedTypes, officeLocation, categoriesSelected, supportAssigned, page])


  return (
    <>

      <Helmet>
        <title>Reporte de tickets | {process.env.REACT_APP_APP_NAME}</title>
      </Helmet>

        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Reporte de tickets
          </Typography>

          <Button onClick={getExcelReport} variant="contained" startIcon={loadingExcelReport ? <CircularProgress size={'15px'} sx={{ color: 'white', marginRight: '6px' }} /> : <Iconify icon="file-icons:microsoft-excel" />}>
            {loadingExcelReport ? "Exportando reporte" : "Exportar reporte"}
          </Button>
        </Stack>


        <Grid item container alignItems={"center"} spacing={2} p={1} >

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker slotProps={{ textField: { size: 'small', fullWidth: true, label: "Fecha inicial" } }} value={startDay} onChange={(e) => {
                setStartDay(dayjs(e).startOf("day"))
              }
              } />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker slotProps={{ textField: { size: 'small', fullWidth: true, label: "Fecha final" } }} value={endDay} onChange={(e) => {
                setEndDay(dayjs(e).endOf("day"))
              }} />
            </LocalizationProvider>
          </Grid>


          <Grid item xs={12} sm={6} md={4} lg={3}>
            <FormControl sx={{ width: "100%" }}>
              <InputLabel
                id="role-label"
                sx={{ marginTop: '-0.4rem' }} // Ajusta el valor según sea necesario
              >
                Estados de tickets
              </InputLabel>
              <Select
                labelId="role-label"
                id="role"
                multiple
                value={selectedTypes}
                onChange={(e) => { setSelectedTypes(e.target.value) }}
                size="small"
                label="Estados de tickets"
              >
                <MenuItem value={"Created"}>Creado</MenuItem>
                <MenuItem value={"Assigned"}>Asignado</MenuItem>
                <MenuItem value={"Finished"}>Finalizado</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <FormControl sx={{ width: "100%" }}>
              <InputLabel
                id="role-label"
                sx={{ marginTop: '-0.4rem' }} // Ajusta el valor según sea necesario
              >
                Especifique el tipo
              </InputLabel>
              <Select
                labelId="role-label"
                id="role"
                multiple
                value={categoriesSelected}
                onChange={(e) => { setCategoriesSelected(e.target.value) }}
                size="small"
                label="Especifique el tipo"
              >
                {categoryList?.map((category) => (
                  <MenuItem value={category} key={category} >{category.displayName}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Autocomplete
              size="small"
              fullWidth
              id="support_assigned"
              open={openSupportList}
              onOpen={() => {
                setOpenSupportLis(true);
              }}
              onClose={() => {
                setOpenSupportLis(false);
              }}
              isOptionEqualToValue={(option, value) => option.displayName === value.displayName}
              defaultValue={{ _id: supportAssigned?._id, displayName: supportAssigned?.displayName }}
              getOptionLabel={(option) => option.displayName}
              options={supportList}
              loading={loading}
              onChange={(_e, value) => {
                if (!value) {
                  setSupportAssigned(null)
                  return
                }
                setSupportAssigned({
                  _id: value?._id || 0,
                  displayName: value?.displayName || "Todos"
                })
              }}
              renderInput={(params) => (
                <TextField
                  fullWidth
                  size="small"
                  {...params}
                  label="Técnico"
                  onChange={(e) => {
                    setFilterName(e.target.value)
                  }}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />

          </Grid>


          <Grid item xs={12} sm={6} md={8} lg={9}>
            <FormControl sx={{ width: "100%" }}>
              <InputLabel
                id="role-label"
                sx={{ marginTop: '-0.4rem' }} // Ajusta el valor según sea necesario
              >
                Seleccione el departamento
              </InputLabel>
              <Select
                labelId="role-label"
                id="role"
                multiple
                value={officeLocation}
                onChange={(e) => { setOfficeLocation(e?.target?.value ? e.target.value : "Todos") }}
                size="small"
                label="Seleccione el departamento"
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      maxWidth: 200
                    },
                  },
                }}
              >
                {officeLocations?.map((item) => (
                  <MenuItem value={item} key={item}>{item}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>


        </Grid>

        <Card sx={{
          border: "1px solid #dfd2d2",
          borderRadius: 4,
          m: 2

        }}>

          <Grid container alignItems={"center"} p={2} justifyContent={"space-between"}>
            <Grid item xs={12} sm={4} md={2} lg={2} xl={2}>
              <Box width={"100%"} textAlign={"center"} p={1} sx={{
                border: "1px solid #d4d1f1",
                borderRadius: 4,
                m: 1
              }}>

                <Typography variant="h4" gutterBottom>
                  Creados
                </Typography>

                <Typography variant="h6" gutterBottom>
                  {
                    loading ? (
                      <CircularProgress size={'15px'} />
                    ) : (
                      Number(ticketsReport?.created || 0)
                    )
                  }
                </Typography>

              </Box>
            </Grid>

            <Grid item xs={12} sm={4} md={2} lg={2} xl={2}>
              <Box width={"100%"} textAlign={"center"} p={1} sx={{
                border: "1px solid #d4d1f1",
                borderRadius: 4,
                m: 1
              }}>

                <Typography variant="h4" gutterBottom>
                  Asignados
                </Typography>

                <Typography variant="h6" gutterBottom>
                  {
                    loading ? (
                      <CircularProgress size={'15px'} />
                    ) : (
                      ticketsReport?.assigned || 0
                    )
                  }
                </Typography>


              </Box>
            </Grid>

            <Grid item xs={12} sm={4} md={2} lg={2} xl={2}>
              <Box width={"100%"} textAlign={"center"} p={1} sx={{
                border: "1px solid #d4d1f1",
                borderRadius: 4,
                m: 1
              }}>

                <Typography variant="h4" gutterBottom>
                  Finalizados
                </Typography>

                <Typography variant="h6" gutterBottom>
                  {
                    loading ? (
                      <CircularProgress size={'15px'} />
                    ) : (
                      ticketsReport?.finished || 0
                    )
                  }
                </Typography>

              </Box>
            </Grid>

            <Grid item xs={12} sm={4} md={2} lg={2} xl={2}>
              <Box width={"100%"} textAlign={"center"} p={1} sx={{
                border: "1px solid #d4d1f1",
                borderRadius: 4,
                m: 1
              }}>

                <Typography variant="h4" gutterBottom>
                  Sin asignar
                </Typography>

                <Typography variant="h6" gutterBottom>
                  {
                    loading ? (
                      <CircularProgress size={'15px'} />
                    ) : (
                      ticketsReport?.created || 0
                    )
                  }
                </Typography>

              </Box>
            </Grid>

            <Grid item xs={12} sm={4} md={2} lg={2} xl={2}>
              <Box width={"100%"} textAlign={"center"} p={1} sx={{
                border: "1px solid #d4d1f1",
                borderRadius: 4,
                m: 1
              }}>

                <Typography variant="h4" gutterBottom>
                  Pendientes
                </Typography>

                <Typography variant="h6" gutterBottom>
                  {
                    loading ? (
                      <CircularProgress size={'15px'} />
                    ) : (
                      (ticketsReport?.created || 0) + (ticketsReport?.assigned || 0)
                    )
                  }
                </Typography>

              </Box>
            </Grid>
          </Grid>
        </Card>

        <Card sx={{
          border: "1px solid #dfd2d2",
          borderRadius: 4,
          m: 1
        }}>
          <TableContainer sx={{ minWidth: 800 }}>

            <Table>
              <UserListHead
                headLabel={TABLE_HEAD_TYPES}
              />
              <TableBody>
                {ticketList.length > 0 && ticketList.map((row) =>

                (
                  <TableRow hover key={row._id} tabIndex={-1} role="checkbox" sx={{ cursor: "pointer" }} >

                    <TableCell align="left">
                      {
                        row?.support_assigned?.displayName || 'N/A'
                      }
                    </TableCell>


                    <TableCell component="th" scope="row" padding="normal">
                      {`${row.departmentShortName || 'TIC'}-${row._id}`}
                    </TableCell>

                    <TableCell component="th" scope="row" padding="normal">
                      {`${row?.requester?.displayName || ''}${row?.requester?.department ? ` (${row?.requester?.department})` : ''}`}
                    </TableCell>

                    <TableCell align="left">
                      {row.status === "Created" ? "Creado" : row.status === "Assigned" ? "Asignado" : "Finalizado"}
                    </TableCell>

                  </TableRow>
                ))}
              </TableBody>

              {
                loading === true &&
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <Paper
                        sx={{
                          textAlign: 'center',
                        }}
                      >

                        <CircularProgress size={"30px"} sx={{ color: "#aa9e97", marginRight: "auto", marginLeft: "auto" }} />

                      </Paper>
                    </TableCell>
                  </TableRow>
                </TableBody>
              }

              {
                (Object.keys(ticketsReport).length < 1 && loading === false) &&
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <Paper
                        sx={{
                          textAlign: 'center',
                        }}
                      >

                        <Typography variant="h6" paragraph>
                          Sin resultados
                        </Typography>

                        <Typography variant="body2">
                          No se encontraron resultados
                        </Typography>
                      </Paper>

                    </TableCell>
                  </TableRow>
                </TableBody>
              }
            </Table>
          </TableContainer>

          <Pagination
            count={totalPages}
            page={page}
            onChange={handleChangePage}

            sx={{ float: "right", margin: 2, color: "#ffe7d9" }}
          />

        </Card>

    </>
  );
}

export default function ReportTicketsPage() {
  return (

    <ReportTicketsPageBase />
  )
}